<template>
  <div id="app">
    <header class="navbar py-0 shadow">
      <a class="navbar-brand text-dark mx-auto">{{ websiteTitle }}</a>
    </header>

    <main>
      <section class="jumbotron text-center bg-white">
        <div class="container">
          <form>
            <ExpirationDate @add="emitExpirationDate" ref="expirationDate"></ExpirationDate>

            <Birthday @add="emitBirthday" ref="birthday"></Birthday>
          </form>
          <button type="button" class="btn btn-outline-primary btn-lg" @click="calculateRenewalTerm">計算する</button>
        </div>
      </section>

      <section class="text-center">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md">
              あなたの免許更新期間は
            </div>
            <div class="col-12 col-md">
              <p class="h3">{{ since }}</p>
            </div>
            <div class="col-12 col-md">
              <p class="h3">〜</p>
            </div>
            <div class="col-12 col-md">
              <p class="h3">{{ until }}</p>
            </div>
            <div class="col-12 col-md">
              です。
            </div>
          </div>
        </div>
      </section>

      <section class="text-center">
        <div class="container">
          <div class="row mt-5">
            <div class="col-12">
              <small>※当サイトの使用及び閲覧は、お客様自身の自己責任でなされるものであり、当サイトの作成者は本情報に基づいて被ったいかなる損害についても一切責任を負いません。</small>
            </div>
          </div>
        </div>
      </section>

      <footer class="footer mt-5">
        <p class="text-muted text-center">&copy; 2020 Hiroaki Ito</p>
      </footer>
    </main>
  </div>
</template>

<script>
import ExpirationDate from './components/expirationDate.vue'
import Birthday from './components/birthday.vue'
import moment from 'moment';

export default {
  components: {
    ExpirationDate,
    Birthday
  },
  data () {
    return {
      websiteTitle: '運転免許証 更新期間計算サイト',
      expirationDate: null,
      birthday: null,
      since: 'XXXX年XX月XX日',
      until: 'XXXX年XX月XX日',
    }
  },
  methods: {
    calculateRenewalTerm: function() {
      this.$refs.expirationDate.emitParentComponent();
      this.$refs.birthday.emitParentComponent();

      /*
       * 例:
       * 免許証の有効期限: 2021年(平成33年)4月2日
       * 誕生日: 3月2日
       */

      // 比較のため誕生日の年を更新する
      let expirationYearBirthday = moment(this.birthday);
      expirationYearBirthday.set('year', this.expirationDate.year());

      if (this.expirationDate.isAfter(expirationYearBirthday)) { // 有効期限 > 誕生日(4/2 > 3/2)の場合
        // 2021/3/2の1ヶ月前から1ヶ月後=2021/2/2～2021/4/2
        this.since = expirationYearBirthday.subtract(1, 'months').format("YYYY年MM月DD日");
        this.until = expirationYearBirthday.add(2, 'months').format("YYYY年MM月DD日");

      } else { // 有効期限 < 誕生日(4/2 < 5/2)の場合
        // 2020/5/2の1ヶ月前から1ヶ月後=2020/4/2～2020/6/2
        expirationYearBirthday.subtract(1, 'years'); // 直前の誕生日を表現するため1年引く
        this.since = expirationYearBirthday.subtract(1, 'months').format("YYYY年MM月DD日");
        this.until = expirationYearBirthday.add(2, 'months').format("YYYY年MM月DD日");

      }
    },
    emitExpirationDate: function(date) {
      this.expirationDate = date;
    },
    emitBirthday: function(date) {
      this.birthday = date;
    },
  }
}
</script>

<style>
  div#app {
    font-family: 'Kosugi Maru', sans-serif;
  }
</style>